import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    background: '#fff',
    color: theme.palette.secondary.main,
    padding: '40px 0px 80px 16px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1280px',
    [theme.breakpoints.down('md')]: {
      padding: '27px 0px 80px 8px',
    },
  },
}))

export default useStyles
